import { motion } from "framer-motion";
import { waLink, GENERAL_MESSAGE } from "@/lib/store";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FloatingWhatsApp = ({ className = "flex" }) => (
  <motion.a
    data-testid="floating-whatsapp-btn"
    href={waLink(GENERAL_MESSAGE)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Falar no WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 20 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.92 }}
    className={`fixed bottom-[calc(env(safe-area-inset-bottom)+20px)] right-5 z-50 ${className} h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-black shadow-[0_10px_40px_rgba(37,211,102,0.35)]`}
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
    <WhatsAppIcon className="relative h-7 w-7" />
  </motion.a>
);
